import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { clearAuthorization } from '../../actions/authorization-actions.js';
import { graphql, compose } from 'react-apollo';
import { Link, withRouter } from 'react-router-dom';
import UserDisplayedName from '../TasksListComponents/UserDisplayedName';
import { CurrentUser } from '../../queries/CurrentUser.js';

const mapDispatchToProps = (dispatch) => {
  return {
    clearAuthorization: () => {
      dispatch(clearAuthorization());
    },
  };
};

const UserAppHeaderDropdown = (props) => {
  const handleClearAuthorization = () => {
    props.clearAuthorization();
    props.history.push('/login');
  };
  const viewer =
    props.data.viewer && UserDisplayedName({ user: props.data.viewer });
  return (
    <Dropdown text={viewer} simple item>
      <Dropdown.Menu>
        <Dropdown.Item onClick={handleClearAuthorization}>Logout</Dropdown.Item>
        <Dropdown.Item as={Link} to='/settings'>
          Account
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default withRouter(
  compose(
    graphql(CurrentUser, { options: () => ({ fetchPolicy: 'cache-and-network' }) })
  )(connect(null, mapDispatchToProps)(UserAppHeaderDropdown))
);



// WEBPACK FOOTER //
// ./src/component/dropdowns/UserAppHeaderDropdown.js